import "./assets/js/nav-pills.js";
import "./assets/scss/ant-design.scss";
import "./assets/scss/common.scss";
import "./assets/scss/certificate-list.scss"
import "./assets/scss/search-filter.scss"
import "./assets/scss/pagination.scss"
import './assets/scss/addItem.scss'
import bootstrap from "bootstrap/dist/js/bootstrap";

export default {
  install() {},
};
